import { Grid } from '@mui/material'
import PublicTemplate from 'components/screens/PublicTemplate'
import React from 'react'
import { useNavigate } from 'react-router'
import { LandingStoreStates } from '.'
import { LandingButton, LandingText, LogoContainer } from './styles'

type OwnProps = {}

type LandingProps = OwnProps & LandingStoreStates

const Landing = (props: LandingProps) => {
  const { auth } = props
  const isLoggedIn = auth.user !== null
  const navigate = useNavigate()

  return (
    <PublicTemplate showLinks>
      <Grid
        container
        direction="column"
        spacing={5}
        sx={{
          alignItems: 'center',
        }}>
        <LogoContainer>
          <img src="/images/logo_large.png" alt="クチヨミ" style={{ width: '100%' }} />
        </LogoContainer>
        <Grid>
          <LandingText variant="h6" align="center">
            国立大学法人九州工業大学 齊藤剛史研究室が提供する読唇技術に関するシステムです。
          </LandingText>
          <LandingText variant="h6" align="center">
            読唇技術の性能評価・性能向上のために発話シーンを投稿するサービスおよび読唇技術のデモを体験するサービスを含みます。
          </LandingText>
        </Grid>
        <Grid>
          <LandingButton
            variant="contained"
            size="large"
            onClick={() => navigate(isLoggedIn ? '/notifications' : '/login')}>
            {isLoggedIn ? 'ホームへ' : '使ってみる'}
          </LandingButton>
        </Grid>
      </Grid>
    </PublicTemplate>
  )
}

export default Landing
